import React, {
  useState, useContext, useEffect, useCallback, useMemo,
} from 'react'
import {
  Box, Loader, Text,
} from '@usap/uicomponents'
import { ReturnItemContext } from '../../../../contexts/ReturnItemContextProvider'
import { SelectedItemsContext } from '../../../../contexts/SelectedItemsContextProvider'
import RMAReturnItemInfo from './RMAReturnItemInfo'
import RMAReturnOrderInfo from './RMAReturnOrderInfo'
import RMAReturnButtons from './RMAReturnButtons'
import RMAReturnStep from './RMAReturnStep'
import Lightbox from '../../../common/Lightbox'
import CancelReturn from '../CancelReturn'
import ErrorMessageLb from '../ErrorMessageLb'
import {
  BUTTON_TEXT_LABEL,
  BUTTON_TEXT_LABEL_WMO,
  SUBMIT_ALL_TEXT,
  buttonLabelText,
  eligibleStatuses,
} from './constant'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import RMAReturnDetailsWMO from './RMAReturnDetailsWMO'

const setItemImage = (imgSource, partSku) => {
  const defaultImage = 'https://cld.partsimg.com/image/upload/d_noimage.jpg'
  if (!imgSource) {
    return `${defaultImage}/images/${partSku.toLowerCase()}_1.jpg`
  }
  return imgSource
}

const getPartEligibilityStatus = (objData, isArray = false) => {
  let isEligible = false
  if (isArray) {
    Object.values(objData).forEach(val => {
      if (!isEligible && val.available_return_qty) {
        const valOrderStatus = val.order_item_status || val.order_item_status_comp
        if (val.components) {
          getPartEligibilityStatus(val.components, Array.isArray(val.components))
        }
        isEligible = eligibleStatuses.includes(valOrderStatus)
      }
    })
  } else if (objData.order_item_status) {
    isEligible = eligibleStatuses.includes(objData.order_item_status)
  } else if (objData.components) {
    getPartEligibilityStatus(objData.components, Array.isArray(objData.components))
  }
  return isEligible
}

const RMAReturnDetails = props => {
  const {
    isDesktop,
    isBot,
    Link,
    data,
    onCancelReturn,
    loading,
    forceMultipleSelect,
    setLoading,
    handleReason,
    setDoneReturn,
    appSteps,
    setAppSteps,
    imgSteps,
    setImgSteps,
    docSteps,
    setDocSteps,
    customerOrder,
    fileUpload,
    setFileUpload,
    formFile,
    setFormFile,
    tempStep,
    setTempStep,
    reqElem,
    setReqElem,
    partSku,
    GTM,
    setReturnQuantity,
    setDisplayReturnDetails,
    tokenCustomerId,
    showTabs,
    setShowTabs,
    setReturnDetailsData,
    mechanicDiagnosis,
    creditStatus,
    returnRequestStatus,
    OpenChatHandler,
  } = props
  const {
    merchant_order_id: merchantOrderId,
    order_id: orderId,
    customers_email_address: emailAddress,
    order_status: orderStatus,
    order_date: orderDate,
    parts,
    return_request: returns,
  } = data

  const { returnRequest, returnComplete, returnFailure } = GTM

  const returnItemContextData = useContext(ReturnItemContext)
  const { setOrderItem } = returnItemContextData

  const selectedItemsContextData = useContext(SelectedItemsContext)
  const {
    orderItems,
    setOrderItems,
    applicationData,
    setApplicationData,
    setSuccessData,
    selectedImages,
    filesUpload,
  } = selectedItemsContextData

  const [selectedPart, setSelectedPart] = useState(null)
  const [selectedPartIndx, setSelectedPartIndx] = useState(0)
  const [selectedPartETA, setSelectedPartETA] = useState(null)
  const [selectedPartStatus, setSelectedPartStatus] = useState(null)
  const [submitSelect, setSubmitSelect] = useState(false)
  const [displayCancel, setDisplayCancel] = useState(false)
  const [displayErrorMessage, setDisplayErrorMessage] = useState(false)
  const isWmoEnabled = useWmoEnabled()
  const [buttonText, setButtonText] = useState(isWmoEnabled ? BUTTON_TEXT_LABEL_WMO : BUTTON_TEXT_LABEL)
  const [errorSteps, setErrorSteps] = useState([])

  const isMultiplePart = useMemo(() => Array.isArray(parts) && !parts.sku, [parts])
  const checkEligibility = useMemo(
    () => getPartEligibilityStatus(parts, isMultiplePart),
    [parts, isMultiplePart],
  )
  const [isPartEligible, setPartEligible] = useState(checkEligibility)
  const [partSelection, setPartsSelection] = useState(parts)
  const [showReason, setShowReason] = useState(isPartEligible)
  const [partReturnEligibilityList, setPartReturnEligibilityList] = useState({});

  const customerInfo = {
    email: emailAddress,
    id: tokenCustomerId,
    orderId,
    orderStatus,
    merchantOrderId,
  }

  const parseOrderItem = useCallback(
    parseData => {
      const {
        brand,
        brandText,
        sku,
        sku_title: skuTitle,
        ETA,
        qty,
        list_price: listPrice,
        warranty_price: warrantyPrice,
        ImageURL,
        modelYear,
        makeText,
        modelText,
        submodel,
        appEngines,
        appFits,
      } = parseData

      return {
        orderNumber: orderId,
        merchantOrderId,
        orderDate,
        brand: brand || null,
        brandText,
        ETA,
        eligibleForReturn: false,
        partNumber: sku,
        partDescription: skuTitle,
        partImage: ImageURL,
        qtyOrdered: qty,
        qtyReturned: qty,
        unitPrice: listPrice,
        warrantyPrice: warrantyPrice || 0.00,
        vehicleSelected: '',
        fitmentGuaranteed: !!appFits,
        emailAddress,
        isMultiplePart,
        vehicle: {
          year: modelYear,
          make: makeText,
          model: modelText,
          submodel,
          engineType: appEngines,
        },
        finish: true,
      }
    },
    [orderId, emailAddress, isMultiplePart, merchantOrderId, orderDate],
  )

  const showErrorMessage = () => {
    setTimeout(() => {
      setDisplayErrorMessage(false)
    }, 3000)
  }

  const addMainOrderInfo = () => {
    setApplicationData({
      email: emailAddress,
      id: tokenCustomerId,
      orderId,
      orderStatus,
      merchantOrderId,
    })
  }

  /* **************************** SUBMIT FORM **************************** */
  const submitForm = async () => {
    if (reqElem.length) {
      const errorData = {}
      let firstRequired = ''

      reqElem.forEach(({ id, type }) => {
        if (type === 'optionSelect') {
          if (id === 'mainReason') {
            if (tempStep && tempStep.length) {
              const element = document.getElementById(tempStep[0].id)
              const event = new Event('click', { bubbles: true })
              element.dispatchEvent(event)
            } else {
              errorData[`${id}`] = 'Please select a reason for your return'
              if (!firstRequired) {
                firstRequired = id
              }
            }
          } else {
            errorData[`${id}`] = 'Please select from the option below'
            if (!firstRequired) {
              firstRequired = id
            }
          }
        } else if (type === 'imageGallery') {
          errorData[`${id}`] = 'Please upload at least 1 photo'
          if (!firstRequired) {
            firstRequired = id
          }
        } else if (type === 'documentLibrary') {
          errorData[`${id}`] = 'Please upload proof of mechanic diagnosis'
          if (!firstRequired) {
            firstRequired = id
          }
        } else if (type === 'textarea') {
          errorData[`${id}`] = 'Please provide details'
          if (!firstRequired) {
            firstRequired = id
          }
        }
      })

      setErrorSteps(errorData)
      handleReason.scrollToElem(`error-${firstRequired}`)
      return false
    }

    /* If Button was set to Done label its behaviour should be change */
    if (buttonText === 'Done') {
      onCancelReturn()
      setOrderItems([])
      return false
    }

    /* Handling error for not yet selection of Reasons */
    if (
      buttonText === 'Return This Part(s)'
      && Array.isArray(parts)
      && orderItems.length === 0
    ) {
      setErrorSteps({
        errorReturnPart: 'Please select a part for your return.',
      })
      handleReason.scrollToElem('error-ReturnPart')
      return false
    }

    try {
      /* if button label is 'Return this items'  */
      if (
        orderItems.length
        && Array.isArray(parts)
        && !buttonLabelText.includes(buttonText)
      ) {
        setShowTabs(true)
        setSubmitSelect(true)
        setPartsSelection(orderItems)
        addMainOrderInfo()
        setSelectedPartStatus(orderItems[`${selectedPartIndx}`].order_item_status)
        setSelectedPart(orderItems[`${selectedPartIndx}`].sku)
        setOrderItem(parseOrderItem(parts[`${selectedPartIndx}`]))
        setSelectedPartETA(orderItems[`${selectedPartIndx}`].ETA)

        const payloadData = handleReason.setPayload(orderItems, customerInfo, 'PUT')
        await handleReason.putApplication(payloadData)

        let buttonLabel = 'Submit'
        if (orderItems.length > 1) {
          buttonLabel = 'Next'
          setSelectedPartIndx(selectedPartIndx + 1)
        }

        setButtonText(buttonLabel)
        handleReason.scrollToElem()
        return true
      }

      /* if button label is 'Next' */
      if (orderItems.length
        && Array.isArray(parts)
        && buttonText === 'Next'
      ) {
        const partNumber = orderItems[`${selectedPartIndx}`].sku
        const skuId = orderItems[`${selectedPartIndx - 1}`].sku
        orderItems[`${selectedPartIndx - 1}`].comment = document.getElementById(`txt${skuId}`).value

        setFormFile({})
        setFileUpload({})
        setErrorSteps([])
        setAppSteps([])
        setTempStep([])
        setSelectedPart(partNumber)
        setOrderItem(parseOrderItem(parts[`${selectedPartIndx}`]))

        const payloadData = handleReason.setPayload(orderItems, applicationData, 'PATCH')
        await handleReason.patchApplication(payloadData)

        if ((selectedPartIndx + 1) === orderItems.length) {
          setButtonText(SUBMIT_ALL_TEXT)
        }

        setSelectedPartIndx(selectedPartIndx + 1)
        handleReason.scrollToElem()
        return false
      }

      if (orderItems.length && Array.isArray(parts) && (buttonText === 'Submit' || buttonText === 'Submit All Returns')) {
        const intLoc = orderItems.length - 1
        const skuId = orderItems[`${intLoc}`].sku
        orderItems[`${intLoc}`].comment = document.getElementById(`txt${skuId}`).value

        const patchPayloadData = handleReason.setPayload(orderItems, applicationData, 'PATCH')
        await handleReason.patchApplication(patchPayloadData)

        setLoading(true)

        const payloadData = handleReason.setPayload(orderItems, applicationData, 'PATCH')

        const postApplicationResult = await handleReason.postApplication(
          payloadData, filesUpload, selectedImages,
        )
        const payloadGTM = handleReason.setGTMPayload(orderItems, applicationData)

        if (postApplicationResult.returnRequestId) {
          returnRequest(payloadGTM)
          returnComplete(payloadGTM, postApplicationResult.returnRequestId)
          setSuccessData(postApplicationResult.returnRequestId)
          setDoneReturn(postApplicationResult.returnRequestId || '')
          setErrorSteps([])
          setFormFile({})
          setFileUpload({})
          setAppSteps([])
          setTempStep([])
          setLoading(false)
          handleReason.scrollToElem()
          return true
        }

        setLoading(false)
        setDisplayErrorMessage(true)
        showErrorMessage()
        returnFailure(payloadGTM, 'failed to get return request id')
        return false

      }
    } catch (err) {
      const payloadGTMdata = handleReason.setGTMPayload(orderItems, applicationData)
      returnFailure(payloadGTMdata, err?.message)
      setLoading(false)
      setDisplayErrorMessage(true)
      showErrorMessage()
      console.error('ssr2: ', err)
    }
    handleReason.scrollToElem()
    return false
  }

  const checkNumberOfReturnable = useCallback(
    () => {
      let ctr = 0
      parts.forEach(partData => {
        if (typeof partData.returnRequest === 'undefined' && eligibleStatuses.includes(partData.order_item_status || 'Pending')) {
          ctr += 1
        }
      })

      return ctr
    },
    [parts],
  )

  useEffect(
    () => {
      handleReason.scrollToElem('headerFirst')
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [submitSelect],
  )

  /* if search order has only one item */
  useEffect(
    () => {
      if (checkNumberOfReturnable() === 0) {
        setButtonText('Done')
      }
      // Single Item
      if (parts.length === 1) {
        const partSelected = parts[0]

        const returnReq = partSelected.returnRequest || ''

        const itemStatus = partSelected.order_item_status || 'Pending'
        let isNotEligible = partSelected.sku !== null
        isNotEligible = (isNotEligible
          && (returnReq || returnReq.return_request_id || returnReq.rma_id))
          || !eligibleStatuses.includes(itemStatus)

        setPartsSelection([partSelected])
        setOrderItem(parseOrderItem(partSelected))
        setButtonText('Done')
        setShowReason(!isNotEligible)
        setPartEligible(!isNotEligible)

        if (!isNotEligible) {
          // Update context
          setOrderItems([...orderItems, {
            ...partSelected,
            displayChatBox: false,
            returnQty: partSelected.available_return_qty || partSelected.qty,
            images: [],
            reasons: [],
            comment: '',
            documents: [],
          }])
          setShowTabs(true)
          setSelectedPartETA(partSelected.ETA)
          setSelectedPartStatus(partSelected.order_item_status)
          setSubmitSelect(true)
          setButtonText('Submit')

          addMainOrderInfo()
          setSelectedPart(partSelected.sku)

          const payloadData = handleReason.setPayload(parts, customerInfo, 'PUT')
          handleReason.putApplication(payloadData)
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [parts],
  )

  /* if coming from order details or track order page, */
  useEffect(
    () => {
      if (partSku && isMultiplePart && !forceMultipleSelect) {
        const index = parts.findIndex(elem => elem.sku === partSku)

        const partSelected = parts[`${index}`]
        const returnReq = partSelected.returnRequest || ''

        let isNotEligible = partSelected.sku !== null
        const itemStatus = partSelected.order_item_status || 'Pending'
        isNotEligible = (isNotEligible
          && (returnReq || returnReq.return_request_id || returnReq.rma_id))
          || !eligibleStatuses.includes(itemStatus)

        setPartsSelection([partSelected])
        setOrderItem(parseOrderItem(partSelected))
        setButtonText('Done')
        setShowReason(!isNotEligible)
        setPartEligible(!isNotEligible)
        if (!isNotEligible) {
          setShowTabs(true)
          setSelectedPart(partSku)
          setSelectedPartETA(partSelected.ETA)
          setSelectedPartStatus(partSelected.order_item_status)
          setSubmitSelect(true)
          setButtonText('Submit')
          addMainOrderInfo()
          setOrderItems([...orderItems, {
            ...partSelected,
            displayChatBox: false,
            returnQty: partSelected.available_return_qty || partSelected.qty,
            images: [],
            reasons: [],
            comment: '',
            documents: [],
          }])

          const payloadData = handleReason.setPayload([parts[`${index}`]], customerInfo, 'PUT')
          handleReason.putApplication(payloadData)
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [parts, partSku],
  )

  const displayCancelConfirmation = () => {
    setDisplayCancel(true)
  }

  const resetReturn = () => {
    const initialState = { orderItem: {} }
    onCancelReturn()
    setOrderItems([])
    setApplicationData(null)
    setSuccessData([])
    setOrderItem(initialState)
    setSelectedPart(null)
    setSelectedPartIndx(0)
    setSelectedPartETA(null)
    setSelectedPartStatus(null)
    setShowTabs(false)
    handleReason.scrollToElem()
  }

  if (isWmoEnabled) {
    return (<RMAReturnDetailsWMO
      {...props}
      resetReturn={resetReturn}
      displayCancelConfirmation={displayCancelConfirmation}
      checkNumberOfReturnable={checkNumberOfReturnable}
      submitForm={submitForm}
      addMainOrderInfo={addMainOrderInfo}
      showErrorMessage={showErrorMessage}
      parseOrderItem={parseOrderItem}
      showReason={showReason}
      partSelection={partSelection}
      setPartsSelection={setPartsSelection}
      isPartEligible={isPartEligible}
      isMultiplePart={isMultiplePart}
      errorSteps={errorSteps}
      setErrorSteps={setErrorSteps}
      buttonText={buttonText}
      setButtonText={setButtonText}
      displayErrorMessage={displayErrorMessage}
      setDisplayErrorMessage={setDisplayErrorMessage}
      displayCancel={displayCancel}
      setDisplayCancel={setDisplayCancel}
      submitSelect={submitSelect}
      selectedPartStatus={selectedPartStatus}
      selectedPartETA={selectedPartETA}
      selectedPartIndx={selectedPartIndx}
      setSelectedPartIndx={setSelectedPartIndx}
      selectedPart={selectedPart}
      setSelectedPart={setSelectedPart}
      setItemImage={setItemImage}
      orderItems={orderItems}
      partReturnEligibilityList={partReturnEligibilityList}
      setPartReturnEligibilityList={setPartReturnEligibilityList}
      setLoading={setLoading}
    />)
  }

  return (
    <>
      <Lightbox key="errorLightbox" isDisplay={displayErrorMessage}>
        <ErrorMessageLb />
      </Lightbox>

      <Lightbox key="cancelLightbox" isDisplay={displayCancel}>
        <CancelReturn
          onCancelReturn={resetReturn}
          setDisplayCancel={setDisplayCancel}
        />
      </Lightbox>

      <Box
        key="returnDetailsMainBox"
        width="100%"
        style={{
          flexDirection: isDesktop && (buttonText !== BUTTON_TEXT_LABEL && buttonText !== 'Done') ? 'row-reverse' : 'column',
        }}
      >
        <Box
          direction="column"
          id="rma-page-2nd-column"
          width="100%"
          pad={isDesktop ? 'small' : '0px'}
        >
          <Box pad={isDesktop ? 'small' : '0px'} justify="start" direction="column">
            <RMAReturnOrderInfo
              key="returnRMAOrderInfo"
              isMultiplePart={isMultiplePart}
              isDesktop={isDesktop}
              isBot={isBot}
              merchantOrderId={merchantOrderId}
              orderDate={orderDate}
              orderStatus={orderStatus}
              errorSteps={errorSteps}
              isPartEligible={isPartEligible}
              setItemImage={setItemImage}
              showTabs={showTabs}
              selectedPartIndx={selectedPartIndx}
              selectedPart={selectedPart}
              showReason={showReason}
            />
          </Box>

          <Box pad={isDesktop ? 'small' : '0px'} justify="start" direction="column">
            {!showTabs && isDesktop && !selectedPart && (
              <Box
                pad={{ horizontal: '16px', vertical: '8px' }}
                justify="start"
                direction="row"
                round="6px"
                style={{
                  backgroundColor: '#F5F5F5',
                  marginBottom: '8px',
                  lineHeight: '18px',
                  fontSize: '12px',
                  fontFamily: 'Roboto',
                  fontWeight: 500,
                  color: '#666666',
                }}
              >
                <Text style={{ width: '75%' }}>ITEM</Text>
                <Text style={{ width: '15%' }}>QTY</Text>
                <Text style={{ width: '15%' }}>ITEM TOTAL</Text>
              </Box>
            )}

            {isMultiplePart
              && partSelection.map((part, ikey) => (
                <>
                  <RMAReturnItemInfo
                    key="multiRMAReturnItemInfo"
                    ikey={ikey}
                    buttonLabel={buttonText}
                    isMultiplePart={isMultiplePart}
                    submitSelect={submitSelect}
                    isDesktop={isDesktop}
                    isBot={isBot}
                    Link={Link}
                    selectedPart={selectedPart}
                    eligibleStatuses={eligibleStatuses}
                    setReturnQuantity={setReturnQuantity}
                    setDisplayReturnDetails={setDisplayReturnDetails}
                    setReturnDetailsData={setReturnDetailsData}
                    parts={part}
                    creditStatus={creditStatus}
                    returnRequestStatus={returnRequestStatus}
                    orderInfo={{
                      merchantOrderId, emailAddress, orderId,
                    }}
                    returns={returns || []}
                    setItemImage={setItemImage}
                    setSelectedPart={setSelectedPart}
                    selectedPartIndx={selectedPartIndx}
                    setSelectedPartIndx={setSelectedPartIndx}
                    showTabs={showTabs}
                    isPartEligible={isPartEligible}
                    setErrorSteps={setErrorSteps}
                    setPartsSelection={setPartsSelection}
                    OpenChatHandler={OpenChatHandler}
                  />
                </>
              ))}

            {!isMultiplePart && (
              <>
                <RMAReturnItemInfo
                  key="singleRMAReturnItemInfo"
                  buttonLabel={buttonText}
                  isMultiplePart={isMultiplePart}
                  isDesktop={isDesktop}
                  showTabs={showTabs}
                  isBot={isBot}
                  selectedPart={selectedPart}
                  eligibleStatuses={eligibleStatuses}
                  setReturnQuantity={setReturnQuantity}
                  setReturnDetailsData={setReturnDetailsData}
                  setDisplayReturnDetails={setDisplayReturnDetails}
                  parts={parts}
                  returns={returns || []}
                  setItemImage={setItemImage}
                  setSelectedPart={setSelectedPart}
                  selectedPartIndx={selectedPartIndx}
                  setSelectedPartIndx={setSelectedPartIndx}
                  creditStatus={creditStatus}
                  returnRequestStatus={returnRequestStatus}
                  orderInfo={{
                    merchantOrderId, emailAddress, orderId,
                  }}
                  isPartEligible={isPartEligible}
                  setErrorSteps={setErrorSteps}
                  setPartsSelection={setPartsSelection}
                  OpenChatHandler={OpenChatHandler}
                />
              </>
            )}
          </Box>
        </Box>

        <Box id="rma-page-1st-column" width="100%" direction="column">
          {((!isMultiplePart && isPartEligible) || (submitSelect && showReason)) && (
            <>
              {loading && <Loader />}
              <Box>
                <RMAReturnStep
                  key="returnRMAStep"
                  isDesktop={isDesktop}
                  selectedPart={selectedPart}
                  handleReason={handleReason}
                  appSteps={appSteps}
                  merchantOrderId={merchantOrderId}
                  setAppSteps={setAppSteps}
                  partSelection={partSelection}
                  imgSteps={imgSteps}
                  setImgSteps={setImgSteps}
                  activeCount={selectedPartIndx}
                  docSteps={docSteps}
                  setDocSteps={setDocSteps}
                  fileUpload={fileUpload}
                  setFileUpload={setFileUpload}
                  customerOrder={customerOrder}
                  formFile={formFile}
                  setFormFile={setFormFile}
                  tempStep={tempStep}
                  setTempStep={setTempStep}
                  reqElem={reqElem}
                  setReqElem={setReqElem}
                  errorSteps={errorSteps}
                  setErrorSteps={setErrorSteps}
                  showErrorMessage={showErrorMessage}
                  displayErrorMessage={displayErrorMessage}
                  setDisplayErrorMessage={setDisplayErrorMessage}
                  selectedPartETA={selectedPartETA}
                  setReturnQuantity={setReturnQuantity}
                  orderStatus={selectedPartStatus}
                  mechanicDiagnosis={mechanicDiagnosis}
                  isBot={isBot}
                  eligibleStatuses={eligibleStatuses}
                  OpenChatHandler={OpenChatHandler}
                />
              </Box>
            </>
          )}

          <RMAReturnButtons
            key="returnBtnComp"
            isDesktop={isDesktop}
            isBot={isBot}
            isPartEligible={isPartEligible}
            setButtonText={setButtonText}
            idName="submitReturnItem"
            displayCancelConfirmation={displayCancelConfirmation}
            submitForm={submitForm}
            buttonLabel={buttonText}
            onCancelReturn={onCancelReturn}
            handleReason={handleReason}
          />

          <Box
            key="needMoreHelpBox"
            align="center"
            direction="row"
            style={{
              textAlign: 'center',
              alignSelf: 'center',
            }}
          >
            <Text size="small">
              {'Need help?'}
            </Text>
            <Box
              margin={{ horizontal: '5px', vertical: '0px' }}
              style={{
                color: '#05629B',
                cursor: 'pointer',
                background: 'none',
                border: 'none',
                padding: 0,
                fontSize: '14px',
              }}
              onClick={OpenChatHandler}
            >
              <Text size="small">
                {'Chat with us'}
              </Text>
            </Box>
          </Box>

        </Box>
      </Box>
    </>
  )
}

export default RMAReturnDetails
